import { createReducer, on } from '@ngrx/store'
import { MainViewActions } from './action-types'
import { DepartmentDto } from '../../../api/backend'

export const initState: IMainViewState = {
    breadcrumbs: [],
    bulkOperations: [],
    bulkOperationUpdate: null,
    contractBulkOperationsLoading: false,
    cuzkPasswordValidityState: null,
    departments: [], // list of available departments
    existContractBulkOperation: false,
    showBulkOperations: false,
    notificationDetail: null,
    messages: [],
    notifications: null,
    notificationsRead: null,
    selectedDepartment: null,
    unreadNotificationsCount: 0,
    readNotificationsCount: 0
}

export const mainViewReducer = createReducer(
    initState,
    on(MainViewActions.updateImportantMessages, (state, props) => {
        let oldMessages = state.messages ? [...state.messages] : []
        oldMessages = oldMessages.filter(msg => msg.id <= -1) // keep only constructed messages from MainViewActions

        const newMessages = props.messages || []

        return {...state, messages: [...newMessages, ...oldMessages]}
    }),
    on(MainViewActions.setBreadcrumbs, (state, props) => {
        // Deep copy to prevent reference mutations
        return {...state, breadcrumbs: props.breadcrumbs.map(bc => ({
            ...bc,
            params: {...bc.params},
            properties: {...bc.properties}
        }))}
    }),
    on(MainViewActions.resetBreadcrumbs, (state) => {
        return {...state, breadcrumbs: [...initState.breadcrumbs]}
    }),
    on(MainViewActions.resetBulkOperations, (state) => {
        return {...state, bulkOperations: [...initState.bulkOperations]}
    }),
    on(MainViewActions.setContractBulkOperationLoading, (state, props) => {
        return {...state, contractBulkOperationsLoading: props.loading}
    }),
    on(MainViewActions.setBulkOperations, (state, props) => {
        return {...state, bulkOperations: props.bulkOperations}
    }),
    on(MainViewActions.setShowBulkOperations, (state, props) => {
        return {...state, showBulkOperations: props.showBulkOperations}
    }),
    on(MainViewActions.setBulkOperationUpdate, (state, props) => {
        return {...state, bulkOperationUpdate: props.bulkOperationUpdate}
    }),
    on(MainViewActions.setExistContractBulkOperation, (state, props) => {
        return {...state, existContractBulkOperation: props.existContractBulkOperation}
    }),
    on(MainViewActions.resetExistContractBulkOperation, (state) => {
        return {...state, existContractBulkOperation: initState.existContractBulkOperation}
    }),
    on(MainViewActions.setNotificationDetailInternal, (state, props) => {
        return {...state, notificationDetail: props.detail}
    }),
    on(MainViewActions.resetNotificationDetail, (state) => {
        return {...state, notificationDetail: initState.notificationDetail}
    }),
    on(MainViewActions.setImportantMessages, (state, props) => {
        return {...state, messages: props.messages}
    }),
    on(MainViewActions.resetUnreadNotificationsCount, (state) => {
        return {...state, unreadNotificationsCount: initState.unreadNotificationsCount}
    }),
    on(MainViewActions.setUnreadNotificationsCountInternal, (state, props) => {
        return {...state, unreadNotificationsCount: props.count}
    }),
    on(MainViewActions.setReadNotificationsCount, (state, props) => {
        return {...state, readNotificationsCount: props.count}
    }),
    on(MainViewActions.resetReadNotificationsCount, (state) => {
        return {...state, readNotificationsCount: initState.readNotificationsCount}
    }),
    on(MainViewActions.setNotifications, (state, props) => {
        return {...state, notifications: props.notifications}
    }),
    on(MainViewActions.resetNotifications, (state) => {
        return {...state, notifications: {...initState.notifications}}
    }),
    on(MainViewActions.setNotificationsRead, (state, props) => {
        return {...state, notificationsRead: props.notifications}
    }),
    on(MainViewActions.resetNotificationsRead, (state) => {
        return {...state, notificationsRead: {...initState.notificationsRead}}
    }),
    on(MainViewActions.setDepartments, (state, props) => {
        return {...state, departments: props.departments}
    }),
    on(MainViewActions.resetDepartments, (state) => {
        return {...state, departments: [...initState.departments]}
    }),
    on(MainViewActions.setSelectedDepartmentInternal, (state, props) => {
        return {...state, selectedDepartment: props.department}
    }),
    on(MainViewActions.resetSelectedDepartment, (state) => {
        return {...state, selectedDepartment: initState.selectedDepartment}
    }),
    on(MainViewActions.setCuzkPasswordValidityState, (state, props) => {
        return {...state, cuzkPasswordValidityState: props.cuzkPasswordValidityState}
    })
)

export interface IMainViewState {
    breadcrumbs: any[];
    bulkOperations: any[];
    bulkOperationUpdate: any;
    contractBulkOperationsLoading: boolean;
    cuzkPasswordValidityState: any;
    departments: any[];
    existContractBulkOperation: boolean;
    showBulkOperations: boolean;
    notificationDetail: any;
    messages: any[];
    notifications: any;
    notificationsRead: any;
    selectedDepartment: DepartmentDto;
    unreadNotificationsCount: number;
    readNotificationsCount: number;
}